/*
 * Copyright (C) 2025 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Directive, ElementRef, effect, inject, input } from '@angular/core';
import { ContentHelper } from '@app/app/shared/helpers/content-helper';
import { ACCESS_TOKEN_STORE_KEY } from '@app/app/user-auth/services/access-token.service';

@Directive({
  standalone: true,
  selector: '[ogHrefWithIframeAccessToken]',
})
export class HrefWithIframeAccessTokenDirective {
  private el = inject(ElementRef);
  ogHrefWithIframeAccessToken = input('');

  constructor() {
    if (!(this.el.nativeElement instanceof HTMLAnchorElement)) {
      console.error('Element is not an anchor');
      return;
    }
    const anchor = this.el.nativeElement as HTMLAnchorElement;
    effect(() => {
      if (anchor.target === '_blank' && ContentHelper.isFrameMode()) {
        anchor.href = appendAccessTokenToHref(this.ogHrefWithIframeAccessToken());
      } else {
        anchor.href = this.ogHrefWithIframeAccessToken();
      }
    });
  }
}

export function appendAccessTokenToHref(href: string): string {
  const hashIndex = href.indexOf('#');
  if (hashIndex > -1) {
    const hrefWithoutHash = href.substring(0, hashIndex);
    const hash = href.slice(hashIndex);
    return `${hrefWithoutHash}${appendAccessTokenToHash(hash)}`;
  } else {
    return `${href}${appendAccessTokenToHash('#')}`;
  }
}

export function appendAccessTokenToHash(hash: string | null): string {
  const accessToken = localStorage.getItem(ACCESS_TOKEN_STORE_KEY);
  const hashNonNull = hash ?? '';
  if (hashNonNull.length > 0 && hashNonNull !== '#') {
    return `${hashNonNull}&access_token=${accessToken}&redirect_here`;
  } else {
    return `${hashNonNull}access_token=${accessToken}&redirect_here`;
  }
}
